/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { getEditPriceReason } from "../../../util/request/getEditPriceReason";
import { CartItem, CheckoutItemPayload } from "../storage/cart.types";

export const productToCheckoutItem = (product: CartItem): CheckoutItemPayload => {
  const editedReason: Partial<CartItem> = getEditPriceReason<CartItem>(product);

  return {
    productId: product.productId,
    quantity: product.quantity,
    editedPriceExcGst: product.editedPriceExcGst,
    ...editedReason,
    lineId: product.lineId as unknown as string,
  };
};
